import React from "react";

let ValueOrPlaceholder = ({value, className = '', isSet = true}) => {
    return value && isSet
        ? <span className={`text-pre-wrap ${className}`}>{value}</span>
        : <div className={`text-muted ${className}`}>—</div>;
}

export default ValueOrPlaceholder
